import type { ReactElement } from "react";
import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { ComboboxWithSelectAll } from "app/pages/sales-intelligence/common-components/dropdown/ComboboxWithSelectAll";
import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import AddListButton from "app/pages/sales-intelligence/modules/leads-search-filters/components/AddListButton/AddListButton";
import type FindExcludeByStaticListsFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/ExcludeByStaticListsFilter/ExcludeByStaticListsFilter";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import { FilterContentContainer } from "../styles";

import { DROPDOWN_BUTTON, FIELD_LABEL, DROPDOWN_PLACEHOLDER, SELECT_ALL_LABEL } from "./const";

const ExcludeByStaticListsFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindExcludeByStaticListsFilter>): ReactElement | null => {
    const items = useMemo(() => {
        return filter.options.map((list) => ({
            id: list.opportunityListId,
            text: list.friendlyName,
        }));
    }, [filter.options]);

    const handleTypeSelection = (selected: string[]) => {
        onFilterUpdate(selected);
    };

    if (!items.length) {
        return (
            <AddListButton
                text={translate("si.lead_gen.excludeByAccountsLists.add_list.text")}
                onClick={() => siNavigator.goToListsHomePage()}
            />
        );
    }

    return (
        <FilterContentContainer>
            <FormFieldLabel text={translate(FIELD_LABEL)}>
                <ComboboxWithSelectAll
                    onSelectionChange={handleTypeSelection}
                    selectedItems={value}
                    items={items}
                    buttonText={translate(DROPDOWN_BUTTON)}
                    hasSearch
                    searchPlaceHolder={translate(DROPDOWN_PLACEHOLDER)}
                    selectAllLabel={translate(SELECT_ALL_LABEL)}
                />
            </FormFieldLabel>
        </FilterContentContainer>
    );
};

export default ExcludeByStaticListsFilter;
